import {createSlice} from '@reduxjs/toolkit'
import IntegrationService from '../../api/integration'
import {toast} from 'react-toastify'
import FormHelper from '../../utils/forms'
import {setConfirmIsActive} from '../alert'

const integrationSlice = createSlice({
    name: 'integrations',
    initialState: {
        integrations: [],
        isFetching: true,
        checkedIntegrations: [],
        isDeleting: false
    },
    reducers: {
        setIntegrations: (state, {payload}) => {
            state.integrations = payload
        },
        setIsFetching: (state, {payload}) => {
            state.isFetching = payload
        },
        setCheckedIntegrations: (state, {payload}) => {
            state.checkedIntegrations = payload
        },
        setIsDeleting: (state) => {
            state.isDeleting = !state.isDeleting
        }
    }
})

export const {setIntegrations, setIsFetching, setCheckedIntegrations, setIsDeleting} = integrationSlice.actions

export default integrationSlice.reducer

export const addNewIntegration = (values, setFieldError, resetForm) => {
    return async(_, getState) => {
        try {
            const {data} = await IntegrationService.addIntegration(getState().teams.selectedTeamId, values)
            toast.success(data?.message)
            resetForm()
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}

export const getIntegrations = (showLoader = true, withZapier) => {
    return async(dispatch, getState) => {
        showLoader && dispatch(setIsFetching(true))
        try {
            const integrations = await IntegrationService.getIntegrations(getState().teams.selectedTeamId, withZapier)
            await dispatch(setIntegrations(integrations))
            return integrations || []
        } catch (e) {
            toast.error(e?.response?.data?.message)
        } finally {
            showLoader && dispatch(setIsFetching(false))
        }
    }
}

export const updateIntegraitonStatus = (integrationId, data, withZapier) => {
    return async(dispatch, getState) => {
        try {
            await IntegrationService.updateIntegraitonStatus(getState().teams.selectedTeamId, integrationId, data, withZapier)
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message)
        }
    }
}

export const deleteIntegration = (integration) => {
    return async(dispatch, getState) => {
        dispatch(setIsDeleting(true))
        try {
            const data = await IntegrationService.deleteIntegration(getState().teams.selectedTeamId, integration?.provider_id, integration?.type)
            dispatch(getIntegrations(false))
            dispatch(setConfirmIsActive(false))
            dispatch(setCheckedIntegrations([]))
            toast.success(data?.message)
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message)
        } finally {
            dispatch(setIsDeleting(false))
        }
    }
}

export const editIntegration = (values, setFieldError, resetForm, integration) => {
    return async(_, getState) => {
        try {
            const {data} = await IntegrationService.editIntegration(getState().teams.selectedTeamId, integration, values)
            toast.success(data?.message)
            resetForm()
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}

export const getComponents = (providerId) => {
    return async(_, getState) => {
        try {
            const {data} = await IntegrationService.getComponents(getState().teams.selectedTeamId, providerId)
            return data?.data?.integrations || []
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
    }
}

export const getResourceIntegrations = id => {
    return async() => {
        try {
            const {data} = await IntegrationService.getResourceIntegration(id)
            return data?.data?.integrations || []
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
    }
}

export const addNewResourceIntegration = (id, values, setFieldError) => {
    return async() => {
        try {
            const {data} = await IntegrationService.addResourceIntegration(id, values)
            toast.success(data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}

export const updateResourceIntegration = (id, integration, values, setFieldError) => {
    return async() => {
        try {
            const {data} = await IntegrationService.updateResourceIntegration(id, integration, values)
            toast.success(data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}

export const deleteResourceIntegrations = (id, integration) => {
    return async() => {
        try {
            const {data} = await IntegrationService.deleteResourceIntegration(id, integration)
            toast.success(data?.message)
            return true
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
    }
}
